// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../types';
import { media } from '../../helpers';
import {
  Wrapper,
} from './atoms';

export const PromotionWrapper = styled<typeof Wrapper, Theme, _>(Wrapper)`
  padding: 0;
  box-shadow: ${props => props.theme.card.boxShadow};
  ${media.md(css`
    padding: 0;
  `)}
  ${media.lg(css`
    padding: 0;
  `)}
`;

export const Container = styled<any, Theme>('article')`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  ${media.xl(css`
    flex-direction: row;
  `)}
`;

export const ContentContainer = styled<any, Theme>('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 1rem;
  width: 100%;

  ${media.xl(css`
    width: 50%;
  `)}
`;

export const PriceWrapper = styled<any, Theme>('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.priceJustifyContent || 'center')};
  margin-bottom: 1em;
`;

export const TitleWrapper = styled<any, Theme>('div')`
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  flex-grow: 1;
`;

export const DiscountWrapper = styled<any, Theme>('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
`;
